"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingTrackingTelemetryProcessor = void 0;
/**
 * MarketingTrackingTelemetryProcessor injects marketing metdata from a
 * MarketingTrackingProvider to all events.
 */
class MarketingTrackingTelemetryProcessor {
    constructor(provider) {
        this.provider = provider;
    }
    processEvent(event) {
        event.marketingTracking =
            this.provider.getMarketingTrackingMetadata() || undefined;
    }
}
exports.MarketingTrackingTelemetryProcessor = MarketingTrackingTelemetryProcessor;
//# sourceMappingURL=marketingTracking.js.map